module.exports = __webpack_public_path__ + "sedaapp.jpg?66d50f7a9c9f7221eb9ceae4717ee4cb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/sedaapp.jpg
// module id = 152
// module chunks = 0